import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { WhatsAppBspConnection } from "@/components/screens/Platforms/WhatsappBspConnection";
import {
  WHATSAPP_BSP_CONNECTION_MESSAGES,
  WhatsAppBspConnectionMessages,
} from "@/messages/platforms/whatsappBspConnection/whatsapp-bsp-connection.messages";
import translationService from "@/services/translation.service";
import { Language } from "@/types/language.types";

const WhatsAppBspPage: React.FC = () => {
  const { lang = "PT-BR" } = useParams<{ lang?: string }>();
  
  const [messages, setMessages] = useState<WhatsAppBspConnectionMessages | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const translations = await translationService.get<WhatsAppBspConnectionMessages>(
          WHATSAPP_BSP_CONNECTION_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(translations);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Erro desconhecido"));
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return (
      <div style={{ padding: "20px" }}>
        <p>Carregando...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px" }}>
        <h2>Erro ao carregar página</h2>
        <p>{error.message}</p>
        <pre>{error.stack}</pre>
      </div>
    );
  }

  if (!messages) {
    return (
      <div style={{ padding: "20px" }}>
        <p>Erro ao carregar mensagens</p>
      </div>
    );
  }

  try {
    return <WhatsAppBspConnection messages={messages} />;
  } catch (err) {
    return (
      <div style={{ padding: "20px" }}>
        <h2>Erro ao renderizar componente</h2>
        <p>{err instanceof Error ? err.message : "Erro desconhecido"}</p>
        <pre>{err instanceof Error ? err.stack : String(err)}</pre>
      </div>
    );
  }
};

export default WhatsAppBspPage;

